import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import fr from "./fr.json";

export const SUPPORTED_LANGS = ["en", "fr"];

export function detectInitialLang() {
  // cookie first
  const match = document.cookie.match(/(?:^|;\s*)lang=(en|fr)/);
  if (match) return match[1];
  const nav = (navigator.language || "en").toLowerCase();
  return nav.startsWith("fr") ? "fr" : "en";
}

export function setLangCookie(lang) {
  document.cookie = `lang=${lang}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, fr: { translation: fr } },
  lng: detectInitialLang(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
